/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Guest_Forbidden_DescInputs */

const vi_meeting_guest_forbidden_desc = /** @type {(inputs: Meeting_Guest_Forbidden_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh bạ khách mời chỉ dành cho người quản trị. Bạn vẫn thêm và chọn khách mời được ngay trong form lịch họp.`)
};

/**

* @param {Meeting_Guest_Forbidden_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const meeting_guest_forbidden_desc = /** @type {((inputs?: Meeting_Guest_Forbidden_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Guest_Forbidden_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_meeting_guest_forbidden_desc(inputs)
});